// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { PaginationModel } from "@insite/client-framework/Types/ApiModels";

// XNG-Changes: shapes for the custom "free-text geolocation search resolved to a
// state/country" feature, kept out of the widget so there is one source of truth.

export type LatLngLike = Pick<google.maps.LatLng, "lat" | "lng">;

export interface GeoLocationStateAndCountry {
    state: string;
    country: string;
    location: LatLngLike;
    isResolved: boolean;
    // XNG-Changes: the area Google recommends displaying for this result, used to zoom the
    // map to a searched state/city/postal code rather than to the dealer pins.
    viewport?: google.maps.LatLngBounds;
    // XNG-Changes: true when the result is an area rather than a precise address
    isArea?: boolean;
}

/** Default/"nothing searched yet" value for GeoLocationStateAndCountry. */
export const emptyGeoLocationStateAndCountry: GeoLocationStateAndCountry = {
    state: "",
    country: "",
    location: {
        lat: () => 0,
        lng: () => 0,
    },
    isResolved: false,
};

export interface DealersDataViewResult<TDealer = unknown> {
    pagination?: PaginationModel;
    value?: TDealer[];
    // XNG-Changes: the widget reads isLoading off this result; it was missing from the type
    isLoading?: boolean;
    defaultRadius: number;
    defaultLatitude: number;
    defaultLongitude: number;
    // XNG-Changes: not present until the API returns dealer types, so optional
    properties?: Record<string, string>;
}

export const LOCATION_FILTER_ALL_PREFIX = "all";

/** Shape of the LocationFinder page's query string. No OOTB equivalent. */
export interface LocationFinderUrlSearch {
    query?: string;
    category?: string;
}
